
import {getCurrentLang} from '../helpers/helper';
export default class GoogleTagManager {
    constructor() {
        // consent_1 = user don't want nothing, we stop pushing dataLayer
        if(document.cookie.includes("RGPD=consent_2") || document.cookie.includes("RGPD=consent_3")) {
            this.newClient = false;
            this.lastSavedCart = {};
            this.ike_cart_add();
            this.ike_cart_remove();
            this.ike_cart_payment_launched();
            this.ike_cart_payment_success();
            this.ike_client_information();
            // this.ike_cart_view();
            this.ike_search();
            this.ike_page_changed();
            this.ike_cart_payment_changed();
            this.ike_notification_exception();
            this.ike_view_item();
            this.ike_select_item();
            this.initEvents();
        }
    }

    /******* HELPERS *******/

    pushEcommerce(event, cart, items, others = null, ecommerceActionField = null){
        if (typeof dataLayer != "undefined"){
            let data = {
                currencyCode: cart.currency.name,
            };
            const eventObjName = this.getEventObjectGU(event);

            if(eventObjName === 'impressions') {
                data[eventObjName] = items;
                data['currencyCode'] = cart.currency.name;
            } else if (eventObjName !== 'checkout_option') {
                data[eventObjName] = {
                    products: items,
                }
            } else {
                data[eventObjName] = {};
            }

            if(ecommerceActionField){
                data[eventObjName]['actionField'] = ecommerceActionField;
            }

            dataLayer.push({ecommerce: null});
            dataLayer.push({
                event: event,
                ecommerce: data,
                ...others
            });
        }
    }

    push(event, data){
        if (typeof dataLayer != "undefined"){
            dataLayer.push({
                event: event,
                ...data
            });
        }
    }

    pushPaymentMethod(cart){
        dataLayer.push({ecommerce: null});
        dataLayer.push({
            ecommerce:{
                checkout_option:{
                    actionField:{
                        option: cart.paymentType,
                        step: 1,
                    }
                }
            }
        })
    }

    getEventObjectGU(event_name) {
        switch (event_name) {
            case 'addToCart':
                return 'add';
            case 'removeFromCart':
                return 'remove';
            case 'checkout':
                return 'checkout';
            case 'purchase':
                return 'purchase';
            case 'view_cart':
                return 'impressions';
            case 'checkoutOption':
                return 'checkout_option';
            case 'impressions':
                return 'impressions';
            default:
                break;
        }
    }

    getItemsFromCart(cart){
        let items = [];

        for(const tariff of Object.values(cart.tariffs ?? [])) {
            const event = cart.events[tariff.event.id];

            items.push({
                name: event.language.name.toLowerCase(),
                id: event.id,
                price: tariff.amount/tariff.ticketscount,
                brand: "Infomaniak Events",
                category: event.genre.language.name,
                variant: tariff.language.name.toLowerCase(),
                position: items.length,
                quantity: tariff.ticketscount
            });
        };

        return items;
    }

    initEvents() {
        if (document.getElementsByClassName('shop-integration')[0]) {
            window.onpagehide = () => {
                if(this.lastSavedCart.tickets?.length > 0) {
                    this.cartRemove({detail: {
                        newCart: {},
                        previousCart: this.lastSavedCart
                    }});
                }
            }
        }
    }

    /*********** ECOMMERCE ***********/

    ike_cart_add() {
        document.addEventListener('ike_cart_add', ike_event => {
            let items = [];
            const cart = ike_event.detail
            this.lastSavedCart = cart;

            for(const [tarifId, tarifCount] of Object.entries(cart.tariffsAdded)) {
                const tarif = cart.tariffs[parseInt(tarifId)];
                const event = cart.events[tarif.event.id];

                items.push({
                    name: event.language.name.toLowerCase(),
                    id: event.id,
                    price: tarif.amount/tarif.ticketscount,
                    brand: "Infomaniak Events",
                    category: event.genre.language.name,
                    variant: tarif.language.name.toLowerCase(),
                    position: items.length,
                    quantity: tarifCount
                 });
            };

            this.pushEcommerce('addToCart', cart, items);
        });
    }

    ike_cart_remove() {
        document.addEventListener('ike_cart_delete', ike_event => {
            this.cartRemove(ike_event);
        });
    }

    cartRemove(ike_event) {
        let items = [];
        const detail = ike_event.detail;
        const newCart = detail.newCart;
        const previousCart = detail.previousCart;
        const newTicketIds = Object.keys(newCart.tickets ?? []);
        const previousTicketIds = Object.keys(previousCart.tickets ?? []);
        this.lastSavedCart = newCart;

        const deletedTicketIds = previousTicketIds.filter(id => !newTicketIds.includes(id));

        for(const deleteTicketId of deletedTicketIds) {
            const ticket = previousCart.tickets[deleteTicketId];
            const event = previousCart.events[ticket.event];
            const tariff = previousCart.tariffs[ticket.tariff];

            items.push({
                name: event.language.name.toLowerCase(),
                id: event.id,
                price: ticket.price.amount,
                brand: "Infomaniak Events",
                category: event.genre.language.name,
                variant: tariff.language.name.toLowerCase(),
                position: items.length,
                quantity: 1,
            });
        };

        // when new cart is undefined, we need currency and total to push ecommerce
        if(!newCart.currency) {
            newCart.currency = {
                name: previousCart.currency.name,
            };
            newCart.topaid = 0;
        }
        this.pushEcommerce('removeFromCart', newCart, items);
    }

    ike_cart_payment_launched() {
        document.addEventListener('ike_cart_payment_launched', ike_event => {
            const cart = ike_event.detail
            this.lastSavedCart = cart;
            this.pushPaymentMethod(cart);
            this.pushEcommerce('checkout', cart, this.getItemsFromCart(cart), null, {step: 2});
        });
    }

    ike_cart_payment_success() {
        document.addEventListener('ike_cart_payment_success', ike_event => {
            const cart = ike_event.detail
            this.lastSavedCart = null;

            const tva = cart.tva ?? 0;
            const tax = tva/100 * cart.topaid;

            const items = this.getItemsFromCart(cart);

            this.pushEcommerce('purchase', cart, items, {
                dimension1: this.getClientStatut(),
                login_state: this.getClientStatut() === 'new client' ? 0 : 1,
            },
            {
                id: cart.uuid, // mandatory
                tax: tax,
                revenue: cart.topaid, // including tax
            });
        });
    }

    ike_client_information() {
        document.addEventListener('ike_client_information', ike_event => {
            this.newClient = ike_event.detail.isNewClient;
        });
    }

    ike_cart_view() {
        document.addEventListener('ike_cart_view', ike_event => {
            const cart = ike_event.detail
            this.lastSavedCart = cart;
            this.pushEcommerce('view_cart', cart, this.getItemsFromCart(cart), null, {list: 'Cart View'});
        });
    }

    ike_cart_payment_changed() {
        document.addEventListener('ike_cart_payment_changed', ike_event => {
            const cart = ike_event.detail;
            this.lastSavedCart = cart;

            this.pushEcommerce('checkoutOption', cart, null, null, {
                option: cart.paymentMethodSelected.db_name,
                step: 1,
            });
        });
    }

    ike_view_item() {
        document.addEventListener('ike_view_item', ike_event => {
            const cart = ike_event.detail.cart;
            this.lastSavedCart = cart;
            const deployedTariffs = ike_event.detail.deployed.tariffs;
            const date = ike_event.detail.date;

            let items = [];

            for(const tariff of Object.values(deployedTariffs ?? [])) {
                items.push({
                    name: date.name.toLowerCase(),
                    id: date.id,
                    price: tariff.float_price,
                    brand: "Infomaniak Events",
                    category: date.genre,
                    variant: tariff.name.toLowerCase(),
                    position: items.length
                });
            };
            this.pushEcommerce('impressions', cart, items);
        });
    }

    ike_select_item() {
        document.addEventListener('ike_select_item', ike_event => {
            const tariff = ike_event.detail.selectedTariff;
            const date = ike_event.detail.date;
            const currency = ike_event.detail.currency;
            const total = ike_event.detail.totalSelected;

            dataLayer.push({ecommerce: null});
            dataLayer.push({
                event: 'productClick',
                ecommerce: {
                    currencyCode: currency.name,
                    click: {
                        products: {
                            name: date.name.toLowerCase(),
                            id: date.id,
                            price: tariff.float_price,
                            brand: "Infomaniak Events",
                            category: date.genre,
                            variant: tariff.name.toLowerCase(),
                            position: 0,
                            quantity: total
                        },
                    }
                }
            });

        });
    }

    /*********** PUSH ***********/

    ike_notification_exception() {
        document.addEventListener('ike_notification_exception', ike_event => {
            this.push('exception', {
                errorMessage: ike_event.detail.exception,
                errorPage: ike_event.detail.path
            });
        });
    }

    ike_search(){
        document.addEventListener('ike_search', ike_event => {
            this.push('search', {searchTerm: ike_event.detail.searchTerm});
        });
    }

    ike_page_changed() {
        document.addEventListener('ike_page_changed', ike_event => {
            this.push('page_view', {
                page_type: 'shop'+ike_event.detail.path,
                lang: getCurrentLang()
            });
        });
    }

    getClientStatut(){
        return this.newClient ? 'new client' : 'existing client'
    }


}
